/* ============================================================
   VIDEO-FEEDBACK · Lieblingscap
   Pfeile blaettern die Reihe weiter, Klick auf eine Kachel startet
   deren Video mit Ton (Browser lassen Ton nur nach echtem Klick
   zu - deshalb kein Autoplay). Ein zweites Video zu starten
   pausiert automatisch das vorherige.
   ============================================================ */
(function () {
  document.querySelectorAll('[data-lc-vf-reihe]').forEach(function (reihe) {
    var links = reihe.closest('.lc-vf').querySelector('[data-lc-vf-links]');
    var rechts = reihe.closest('.lc-vf').querySelector('[data-lc-vf-rechts]');
    var laufendes = null;

    function kartenBreite() {
      var karte = reihe.querySelector('.lc-vf__karte');
      if (!karte) return reihe.clientWidth;
      var stil = getComputedStyle(reihe);
      return karte.getBoundingClientRect().width + parseFloat(stil.gap || 14);
    }

    function pfeileAktualisieren() {
      if (!links || !rechts) return;
      links.disabled = reihe.scrollLeft <= 2;
      rechts.disabled = reihe.scrollLeft >= reihe.scrollWidth - reihe.clientWidth - 2;
    }

    if (links) links.addEventListener('click', function () {
      reihe.scrollBy({ left: -kartenBreite(), behavior: 'smooth' });
    });
    if (rechts) rechts.addEventListener('click', function () {
      reihe.scrollBy({ left: kartenBreite(), behavior: 'smooth' });
    });
    reihe.addEventListener('scroll', pfeileAktualisieren);
    window.addEventListener('resize', pfeileAktualisieren);
    pfeileAktualisieren();

    reihe.querySelectorAll('[data-lc-vf-karte]').forEach(function (karte) {
      var media = karte.querySelector('.lc-vf__media');
      var video = karte.querySelector('video');
      var knopf = karte.querySelector('[data-lc-vf-abspielen]');
      if (!video || !knopf) return;

      knopf.addEventListener('click', function () {
        if (laufendes && laufendes !== video) {
          laufendes.pause();
          laufendes.closest('.lc-vf__media').classList.remove('ist-aktiv');
        }
        video.muted = false;
        video.play();
        media.classList.add('ist-aktiv');
        laufendes = video;
      });

      video.addEventListener('pause', function () {
        media.classList.remove('ist-aktiv');
        if (laufendes === video) laufendes = null;
      });
      video.addEventListener('ended', function () {
        media.classList.remove('ist-aktiv');
        if (laufendes === video) laufendes = null;
      });
    });
  });
})();